import { SimpleCatchError } from "../../utils/Helper";
import { Axios } from "../../utils/axiosMiddleware";

export const cancelContractRequest = async (payload, navigate) => {
  try {
    await Axios.post(`message-files/contract/cancel`, payload);
    navigate("/contract-lists");
  } catch (e) {
    SimpleCatchError(e);
  }
};
